/*!
 * Mobile Genome (Development Release)
 * Copyright 2014 NogginLabs, Inc.
 * Authored by: NogginLabs Programming Team
 */

define('screens/scenario-mapper/scenario-link',['require','underscore','screens/scenario-mapper/scenario-asset'],function(require) {
  'use strict';

  /////////////
  // IMPORTS /{
  /////////////

  //var $ = require('jquery');
  var _ = require('underscore');
  //var templates = require('core/templates');
  //var Scenario = require('screens/scenario-mapper/scenario');
  var ScenarioAsset = require('screens/scenario-mapper/scenario-asset');

  var Scenario;
  require(['screens/scenario-mapper/scenario'], function(a) {
    Scenario = a;
  });
  var ScenarioDialog;
  require(['screens/scenario-mapper/scenario-dialog'], function(a) {
    ScenarioDialog = a;
  });
  //var ScenarioDialog = require('screens/scenario-mapper/scenario-dialog');

  /*****************************************************************************************************************///}

  var ScenarioLink = ScenarioAsset.extend({

  /////////////////
  // PROPERTIES //{
  /////////////////

    originConvoID: null,
    destinationConvoID: null,
    originDialogID: null,
    destinationDialogID: null,

  /*****************************************************************************************************************///}

  //////////////
  // METHODS //{
  //////////////

    initialize: function(options)
    {
      ScenarioLink.instancesArr.push(this);
      ScenarioAsset.prototype.initialize.apply(this, arguments);
    },

    originConvo: function()
    {
      return Scenario.singleton.getConversationByID(this.originConvoID);
    },

    destinationConvo: function()
    {
      return Scenario.singleton.getConversationByID(this.destinationConvoID);
    },

    originDialog: function()
    {
      return ScenarioDialog.getDialogByID(this.originDialogID, this.originConvo());
    },

    destinationDialog: function()
    {
      return ScenarioDialog.getDialogByID(this.destinationDialogID, this.destinationConvo());
    },

    onBeforeDestroy: function()
    {

    },

    parseData: function(data)
    {
      this.saType = ScenarioAsset.SA_TYPE_LINK;

      this.originConvoID = data.OriginConvoID.toString();
      this.destinationConvoID = data.DestinationConvoID.toString();
      this.originDialogID = data.OriginDialogID.toString();
      this.destinationDialogID = data.DestinationDialogID.toString();
    }

  /*****************************************************************************************************************///}

  });

  ScenarioLink.instancesArr = [];
  ScenarioLink.destroy = function()
  {
    _.each(ScenarioLink.instancesArr, function(instance) {
      instance.destroy();
    });

    ScenarioLink.instancesArr = [];
  };

  return ScenarioLink;

});

